import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

export const FILTER_TABS = [
   { key: 'streams', label: 'Stream' },
   { key: 'tags', label: 'Tag' },
   { key: 'ips', label: 'IP' },
   { key: 'jtis', label: 'JTI' },
   { key: 'referrers', label: 'Referrer' },
   { key: 'countries', label: 'Country' },
   { key: 'providers', label: 'Provider' },
   { key: 'users', label: 'User' },
];

const TabBar = styled.div`
   display: flex;
   flex-wrap: wrap;
   justify-content: center;
   gap: 4px;
   margin-top: 2px;
`;
TabBar.displayName = 'TabBar';

const TabButton = styled.button`
   position: relative;
   display: inline-flex;
   align-items: center;
   gap: 5px;
   padding: 4px 12px;
   border: 1px solid ${(p) => (p.$active ? '#20a8d8' : '#c8ced3')};
   border-radius: 4px;
   background: ${(p) => (p.$active ? '#20a8d8' : '#fff')};
   color: ${(p) => (p.$active ? '#fff' : '#4e5d6c')};
   font-size: 13px;
   cursor: pointer;
   white-space: nowrap;
   transition: border-color 0.15s, background 0.15s, color 0.15s;

   &:hover {
      border-color: #20a8d8;
      color: ${(p) => (p.$active ? '#fff' : '#20a8d8')};
   }

   &:focus {
      outline: none;
   }
`;
TabButton.displayName = 'TabButton';

const CountBadge = styled.span`
   display: inline-flex;
   align-items: center;
   justify-content: center;
   background: ${(p) => (p.$active ? 'rgba(255,255,255,0.35)' : '#20a8d8')};
   color: ${(p) => (p.$active ? '#fff' : '#fff')};
   border-radius: 9px;
   font-size: 10px;
   font-weight: 600;
   min-width: 16px;
   height: 16px;
   padding: 0 4px;
`;
CountBadge.displayName = 'CountBadge';

function FilterTabBar({ activeTab, onTabClick, filterCounts }) {
   return (
      <TabBar>
         {FILTER_TABS.map(({ key, label }) => {
            const count = filterCounts[key] ?? 0;
            const isActive = activeTab === key;
            return (
               <TabButton key={key} type='button' $active={isActive} onClick={() => onTabClick(key)}>
                  {label}
                  {count > 0 && <CountBadge $active={isActive}>{count}</CountBadge>}
               </TabButton>
            );
         })}
      </TabBar>
   );
}

FilterTabBar.propTypes = {
   activeTab: PropTypes.string,
   onTabClick: PropTypes.func.isRequired,
   filterCounts: PropTypes.object.isRequired,
};

export default FilterTabBar;
